module.exports = __webpack_public_path__ + "img/ico-rough-construction-completion-done.08c48b76.svg";